import React from 'react';
import Alert from '@narvar/nth-block-alert';
import { useTheme, withThemeProvider } from '@narvar/nth-hook-theme';

type Props = {
  children: React.ReactNode;
  dismissOnClick: () => void;
  featureName: string;
};

const PanelContainer: React.FC<Props> = ({
  children,
  dismissOnClick,
  featureName,
}) => {
  const { panelcontainerNoneNone: panelcontainerStyle } = useTheme();

  const { marginBottom } = panelcontainerStyle || {};

  return (
    <div
      style={{
        paddingBottom: marginBottom || '0.5rem',
        // TODO: remove when component is in `nth`.
        // hide until useTheme returns an actual value to avoid flash of defaults
        display: panelcontainerStyle ? 'block' : 'none',
      }}
    >
      <Alert
        featureName={featureName}
        //      show={deliveryInstructionsState.visible}
        show
        dismissible
        dismissOnClick={dismissOnClick}
      >
        {children}
      </Alert>
    </div>
  );
};

export default withThemeProvider(PanelContainer, {
  themeTokens: ['panelcontainerNoneNone'],
});
